(ns manage.content-variant-ocp.db.schedule
  (:require [clojure.spec.alpha :as spec]
            [common.form.core :as form]
            [common.loader.db :as loader.db]
            [common.ocp.db]
            [manage.content-variant-ocp.db.core :as ocp-core]
            [manage.resource.feed-imports :as feed-imports]
            [mate.re-frame :as mr]
            [re-frame.core :as rf]))

(def interval-options
  [{:label "No schedule"
    :value nil
    :id :none}
   {:label "Every 10 minutes"
    :value "0 */10 * ? * *"
    :id :10minutes}
   {:label "Every 1 hour"
    :value "0 0 * ? * *"
    :id :hourly}
   {:label "Every 1 day"
    :value "0 0 0 * * ?"
    :id :daily}])

(spec/def ::value (set (map :value interval-options)))

(defn timezone-string []
  (let [offset (-> (.getTimezoneOffset (js/Date.))
                   (/ 60)
                   (* -1))]
    (str "(UTC" (if (neg? offset) "-" "+") offset ") "
         (.-timeZone (.resolvedOptions (js/Intl.DateTimeFormat))))))

(def validate-form
  (rf/enrich (form/get-validate-form-fn :form.content-variant.feed-schedule ::value)))

(rf/reg-event-fx :form.content-variant.feed-schedule/update-scheduling
  [(rf/inject-cofx :sub :resource.user/token)
   (rf/inject-cofx :sub :url-context)
   validate-form]
  (fn [{:keys [db resource.user/token url-context]} [_ payload next-tab]]
    (let [feed-id (get-in db [:resource.adset/one :value :feedId])
          payload* (assoc payload :id feed-id)]
      (-> {:db db}
          (loader.db/open-loader)
          (feed-imports/http-patch-feed url-context payload* token {:on-success [:form.content-variant.feed-schedule/update-schedule-success next-tab]
                                                                    :on-failure [:form.content-variant.feed-schedule/update-schedule-failure]})))))

(rf/reg-event-fx :form.content-variant.feed-schedule/update-schedule-success
  (fn [{:keys [db]} [_ next-tab response]]
    (-> {:db db}
        (feed-imports/on-feed-importers-one-success response)
        (loader.db/close-loader)
        (mr/conj-fx [:dispatch [:response-handler/handle-response
                                {:entity-name ocp-core/entity-name
                                 :type :success
                                 :message (get-in ocp-core/ui-messages [:edit :success])}]])
        (cond-> (nil? (next-tab))
          (mr/conj-fx [:dispatch [:ocp/close]])))))

(rf/reg-event-fx :form.content-variant.feed-schedule/update-schedule-failure
  (fn [{:keys [db]} [event response]]
    (-> {:db db}
        (loader.db/close-loader)
        (mr/conj-fx [:dispatch [:response-handler/handle-response
                                {:entity-name ocp-core/entity-name
                                 :type :error
                                 :event event
                                 :message (get-in ocp-core/ui-messages [:edit :failure])
                                 :response response}]]))))

(def use-error-message (partial form/use-error-message :form.content-variant.feed-schedule))

(def use-bind-control (partial form/use-bind-control :form.content-variant.feed-schedule))

(rf/reg-event-fx :form.content-variant.feed-schedule/open
  [(rf/inject-cofx :sub :resource.feed-importers/one)]
  (fn [{:keys [db]
        :resource.feed-importers/keys [one]} _]
    (let [value (-> (get one :value)
                    (select-keys [:schedule]))]
      {:db (assoc-in db [:form.content-variant.feed-schedule] {:value value})
       :fx [[:dispatch [:form.content-variant.feed-schedule/init value]]]})))

(form/register-form {:namespace :form.content-variant.feed-schedule
                     :validate-form validate-form
                     #_#_:initial-value initial-value
                     :submit-event :form.content-variant.feed-schedule/update-scheduling})
